/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Language_DescInputs */



/**
* | output |
* | --- |
* | "Language of the interface and of automatically generated reports." |
*
* @param {Settings_Language_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_language_desc = /** @type {((inputs?: Settings_Language_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Language_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Taal van de interface en van automatisch gegenereerde verslagen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Langue de l'interface et des comptes rendus générés automatiquement.")
	return /** @type {LocalizedString} */ ("Language of the interface and of automatically generated reports.")
});